import styled from '@emotion/styled';

import { ButtonWithLoading } from 'components/buttons/buttonWithLoading';

export const SectionWrapper = styled.div(() => ({
  display: 'flex',
  padding: 10,
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: 15,
  alignSelf: 'stretch',
}));

export const Item = styled.div(() => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: 20,
  width: '100%',
}));

export const ItemName = styled.div((props) => ({
  width: 170,
  minWidth: 150,
  color: props.theme.colors.inactive,
  fontSize: 13,
  fontWeight: 400,
}));

export const ItemValue = styled.div(() => ({
  display: 'flex',
  gap: 20,
  fontSize: 13,
  fontWeight: 400,
}));

export const SecondaryItemValue = styled(ItemValue)(({ theme }) => ({
  fontFamily: theme.fonts.secondary,
  fontSize: 14,
}));

export const StyledButton = styled(ButtonWithLoading)(() => ({
  padding: 3,
  marginLeft: 'auto',
}));
